import React, { Component } from 'react'
import logo from '../images/Ozen_logo.png'
import { FaAlignRight } from 'react-icons/fa'
import { Link } from 'react-router-dom'

export default class Navbar extends Component {
    state = {
        isOpen: false
    }
    handleToggle = () => {
        this.setState({ isOpen: !this.state.isOpen })
    }
    render() {
        return (
            <nav className="navbar">
                <div className="nav-phoneNumber">
                    +1 519-642-2558
                </div>
                <div className="nav-center" >
                    <div className="nav-header">
                        <Link to="/">
                            <img src={logo} alt="Ozen Restaurant" />
                        </Link>
                        <button type="button" className="nav-btn" onClick={this.handleToggle}>
                            <FaAlignRight className="nav-icon" />  {/* navigation bar icon (Hamberger icon) */}
                        </button>
                    </div>

                    <ul className={this.state.isOpen ? "nav-links show-nav" : "nav-links"}> {/* the class name is defined depends on the false or true. */}

                        <li onClick={this.handleToggle}>
                            <Link to="/">Home</Link>
                        </li>
                        <li onClick={this.handleToggle}>
                            <Link to="/menu">Menu</Link>
                        </li>
                        <li onClick={this.handleToggle}>
                            <Link to="/hours">Hours&Location</Link>
                        </li>
                        <li onClick={this.handleToggle}>
                            <Link to="/about">About</Link>
                        </li>
                        <div className="nav-info">

                            <p>607 Richmond St, London, ON N6A 3G3</p>
                        </div>

                    </ul>

                </div> {/* End - nav-center */}


            </nav>
        )
    }
}
